import { useMutation, useQuery } from '@apollo/client';
import showMessages from '@hooks/apollo/showMessages';
import { GET_WIDGET } from '@modules/widgets/api/GetWidget';
import { UPDATE_WIDGET } from '@modules/widgets/api/UpdateWidget';
import { IFormValues, validationSchema } from '../constants/formik';
import arrayToObject from '../utils/arrayToObject';

interface IProps {
  onResolve: () => void;
  widgetId?: string;
  propKey?: string;
}

const useForm = ({ onResolve, widgetId, propKey }: IProps) => {
  const [editWidget, { loading }] = useMutation(UPDATE_WIDGET, {
    ...showMessages,
  });

  const { data, loading: loadingWidgets } = useQuery(GET_WIDGET, {
    variables: { objId: widgetId },
    fetchPolicy: 'network-only',
  });

  const action = data?.object.objectProperties?.find((obj) => obj.key === propKey)?.value;
  const valueAction = data?.object?.objectProperties?.find((obj) => obj.key === 'valueAction')?.value;

  const formik = {
    initialValues: {
      widgetId,
      propKey,
      control: action?.rpc || '',
      parameters: [],
    },
    validationSchema,
    onSubmit: ({ control, parameters }: IFormValues) => {
      void editWidget({
        variables: {
          widgetId,
          values: [
            {
              propertyKey: propKey,
              value: {
                rpc: control,
                params: { ...arrayToObject(parameters), device: valueAction?.objectId, rpc: control },
              },
            },
          ],
        },
      }).then(() => {
        onResolve();
      });
    },
  };

  return { formik: data && formik, isLoading: loading || loadingWidgets };
};

export default useForm;
